import { ContentFlexComponent } from "components/flexComponents/Content/typings";
import CardWithLinkEditorial from "components/flexComponents/Content/factory/impl/editorials/CardWithLinkEditorial";

export class FullBleedVerticalCard extends CardWithLinkEditorial {
  /* istanbul ignore next */
  constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  public getEditorialItemClassName = (): string => "all-y-gutter-three";
}

export default FullBleedVerticalCard;
